module.exports = __webpack_public_path__ + "assets/check-in-success-bg-fce731ad.png";